// extracted by mini-css-extract-plugin
module.exports = {"cartButton":"ProductForm_cartButton__G7ENT","actions":"ProductForm_actions__AAQi3","link":"ProductForm_link__7u_tY"};